<div class="app">
  <tui-root style="height: 100%">
    <app-navbar></app-navbar>

    <div class="app-content">
      <router-outlet></router-outlet>
    </div>
  </tui-root>
</div>
